import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { RequestsDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformRequestDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { JsonApiResource } from 'types/store/jsonApi';
import { RequestDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownRequestsAdapter =
  createEntityAdapter<RequestsDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownRequestsSlice = createSlice({
  name: 'normalized/insightDrilldownRequests',
  initialState: insightDrilldownRequestsAdapter.getInitialState(),
  reducers: {
    addRequests: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const requestDrilldowns = transformRequestDrilldownData(
        action.payload as JsonApiResource<RequestDrillDownApiResponse>[]
      );
      insightDrilldownRequestsAdapter.setMany(state, requestDrilldowns);
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors =
  insightDrilldownRequestsAdapter.getSelectors<RootState>(
    (state) => state.normalized.insightDrilldownRequests
  );

const selectRequestsByIds = (
  state: RootState,
  ids: string[]
): RequestsDrillDownItem[] =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownRequestsSelectors = {
  ...defaultSelectors,
  selectRequestsByIds,
};
export const { addRequests } = insightDrilldownRequestsSlice.actions;
export default insightDrilldownRequestsSlice.reducer;
